import { v4 as uuidv4 } from 'uuid';
import { getIdToken } from '../authUtils';
import { ApiError } from '../errors';

export const API_NAME = 'nba-admin-portal-api';

export const getConfig = async (body = undefined) => {
    return {
        headers: {
            Authorization: await getIdToken(),
            'X-Correlation-Id': uuidv4(),
            'X-Channel': 'WEBSITE',
            'X-cc-user': 'externalSystem1',
        },
        body,
    };
};
export const validateResponse = (resp) => {
    return resp;
};
export const handleError = (err) => {
    throw new ApiError(err);
};
